(() => {
  if (customElements.get('uathayam-mobile-menu')) return;

  class UathayamMobileMenu extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.root = this.querySelector('[data-menu-root]');
      this.back = this.querySelector('[data-menu-back]');
      this.scroll = this.querySelector('[data-menu-scroll]');
      this.panels = [...this.querySelectorAll('[data-menu-panel]')];
      this.drawer = this.closest('#NavDrawer');

      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-menu-open]');
        if (trigger) this.openPanel(trigger);
        if (event.target.closest('[data-menu-back]')) this.showRoot(true);
      }, { signal });

      this.addEventListener('toggle', event => {
        const category = event.target;
        if (!category.matches('.u-menu__category') || !category.open) return;
        category.parentElement.querySelectorAll('.u-menu__category').forEach(other => {
          if (other !== category) other.open = false;
        });
        // Closing an earlier category can move the new heading above the viewport.
        requestAnimationFrame(() => {
          const heading = category.querySelector('summary');
          const offset = heading.getBoundingClientRect().top - this.scroll.getBoundingClientRect().top;
          if (offset < 0) this.scroll.scrollTop += offset;
        });
      }, { capture: true, signal });

      this.drawer.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        // Recalculate on each Tab: panels and native details change the visible controls.
        const controls = [...this.drawer.querySelectorAll('a[href], button, input, summary, [tabindex="0"]')]
          .filter(element => element.getClientRects().length && !element.disabled);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }, { signal });

      document.addEventListener('drawerOpen.NavDrawer', () => {
        this.showRoot(false);
        this.querySelector('.js-drawer-close').focus();
      }, { signal });

      document.addEventListener('shopify:block:select', event => {
        if (event.target.closest('uathayam-mobile-menu') === this && window.theme?.NavDrawer) {
          window.theme.NavDrawer.open();
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    openPanel(trigger) {
      const panel = this.panels.find(item => item.id === trigger.dataset.menuOpen);
      if (!panel) return;
      this.activeTrigger = trigger;
      this.rootScroll = this.scroll.scrollTop;
      this.root.hidden = true;
      this.panels.forEach(item => { item.hidden = item !== panel; });
      this.back.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      this.scroll.scrollTop = 0;
      panel.querySelector('[data-menu-heading]').focus({ preventScroll: true });
    }

    showRoot(restoreFocus) {
      this.panels.forEach(panel => { panel.hidden = true; });
      this.root.hidden = false;
      this.back.hidden = true;
      this.querySelectorAll('[data-menu-open]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      this.scroll.scrollTop = restoreFocus ? (this.rootScroll || 0) : 0;
      if (restoreFocus) this.activeTrigger?.focus({ preventScroll: true });
    }
  }

  customElements.define('uathayam-mobile-menu', UathayamMobileMenu);
})();
